import {
  getUserFirstNameFromCookies,
  getUserLastNameFromCookies,
} from './getUserDetailsUtil'
import { headers } from './headers'
import { KLAVIYO_PUBLIC_API_KEY } from '../../../constants/index'

export const createKlaviyoProfile = (email, firstName, lastName) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'profile',
        attributes: {
          properties: {
            $email: email,
            $first_name: firstName,
            $last_name: lastName,
          },
        },
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/profiles/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo upadting profile success', response)
  })
  .catch(err => console.log('Filed to update klaviyo profile', err))
}

export const trackUserSignedUp = async (email, firstName, lastName) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            $email: email,
            $first_name: firstName,
            $last_name: lastName,
          },
          metric: {data: {type: 'metric', attributes: {name: 'User Signed Up'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                last_name: lastName,
                properties: {
                  $email: email,
                  $first_name: firstName,
                  $last_name: lastName,
                }, //An object containing key/value pairs for any custom properties assigned to this profile
              }
            }
          }
        }
      }
    })
  }

  await fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking user signed-up success', response)
  })
  .catch(err => {
    console.log('Failed to track klaviyo user signed-up', err)
  })
}

export const subscribeUser = async (email) => {
  const options = {
    method: 'POST',
    headers: {revision: '2024-06-15', 'content-type': 'application/json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: getUserFirstNameFromCookies() ?? '',
                last_name: getUserLastNameFromCookies() ?? '',
                properties: {
                  $fields: '$first_name,$last_name',
                  $first_name: getUserFirstNameFromCookies() ?? '',
                  $last_name: getUserLastNameFromCookies() ?? '',
                }
              },
            }
          }
        },
        relationships: {list: {data: {type: 'list', id: 'R9hYxA'}}}
      }
    })
  }

  await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo subscription success', response)
  })
  .catch(err => {
    console.log('Failed klaviyo subscriptin', err)
  })
}
